module.exports = __webpack_public_path__ + "static/media/file.c72dfa70.svg";